import { get, writable } from "svelte/store";

function createMyWorkoutStore() {
  const itemName = "myWorkouts";
  const retrieved = localStorage.getItem(itemName);
  const parsed = JSON.parse(retrieved);
  const myWorkouts = writable(parsed === null ? [] : parsed);

  myWorkouts.subscribe((value) =>
    localStorage.setItem(itemName, JSON.stringify(value))
  );

  const { subscribe } = myWorkouts;

  return {
    subscribe,
    add: (workout) =>
      myWorkouts.update((oldWorkout) => [workout, ...oldWorkout]),
    remove: (id) =>
      myWorkouts.update((oldWorkout) => oldWorkout.filter((w) => w.id !== id)),
    edit: (id) =>
      myWorkouts.update((oldWorkout) => {
        let objIndex = oldWorkout.findIndex((obj) => obj.id == id);
        oldWorkout[objIndex].isEdit = !oldWorkout[objIndex].isEdit;
        return oldWorkout;
      }),
    updateName: (id, name) =>
      myWorkouts.update((oldWorkout) => {
        let objIndex = oldWorkout.findIndex((obj) => obj.id == id);
        oldWorkout[objIndex].name = name;
        oldWorkout[objIndex].isEdit = !oldWorkout[objIndex].isEdit;
        const url = new URL(oldWorkout[objIndex].url);
        if (url.searchParams.has("n")) {
          url.searchParams.set("n", name);
          oldWorkout[objIndex].url = url;
        }
        return oldWorkout;
      }),
    update: (id, workout) =>
      myWorkouts.update((oldWorkout) => {
        let objIndex = oldWorkout.findIndex((obj) => obj.id == id);
        oldWorkout[objIndex] = workout;
        return oldWorkout;
      }),
    get: (id) => {
      let work = get(myWorkouts);
      let objIndex = work.findIndex((obj) => obj.id == id);
      return work[objIndex];
    },
  };
}

export const myWorkouts = createMyWorkoutStore();
